export default "__VITE_PUBLIC_ASSET__4af63dd5__"